































import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import { Routes } from '@front-app/constants/routes';
import { getSurveysStore } from '@front-app/modules/surveys/store/SurveysStore';
import SurveyEditor from '@front-app/modules/surveys/SurveyEditor.vue';
import { Size } from '@front-app/components/constants';
import { defineComponent } from '@vue/composition-api';

const toSurveyList = { name: Routes.GROUP_ADMIN_LEARNING_PROGRAMS_MANAGE_SURVEYS };

export default defineComponent({
	components: {
		SurveyEditor,
		ColumnHeader,
		XButton,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		surveyId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const toSurveysList = { name: Routes.GROUP_ADMIN_SURVEY_MANAGEMENT_LIST };
		const surveysStore = getSurveysStore();
		const deleteSurvey = () => {
			// eslint-disable-next-line no-alert
			const shouldDelete = window.confirm('Are you sure you want to delete this survey? This action is irreversible, and any users who have completed it will lose their progress.');
			if (shouldDelete) {
				surveysStore.deleteSurvey(props.surveyId);
			}
			ctx.root.$router.push(toSurveyList);
		};
		return {
			toSurveysList,
			deleteSurvey,
			Size,
		};
	},
});
